module.exports = __webpack_public_path__ + "static/media/trash-undo.a822881b.svg";